import { render, staticRenderFns } from "./edit-ceping.vue?vue&type=template&id=3aa07c42&scoped=true"
import script from "./edit-ceping.vue?vue&type=script&lang=ts"
export * from "./edit-ceping.vue?vue&type=script&lang=ts"
import style0 from "./edit-ceping.vue?vue&type=style&index=0&id=3aa07c42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa07c42",
  null
  
)

export default component.exports